import styled from 'styled-components';
import { marginLeft as layoutMarginLeft } from '@Utils/layout/layoutSupport';

export const Container = styled.div<{ marginLeft: number }>`
	flex-direction: row;
	display: flex;
	margin-top: 24px;
	${({ marginLeft }) => layoutMarginLeft(marginLeft)}
`;
